import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { SvgName } from "@models";
import { TranslatePipe } from "@pipes";

import { AmountComponent } from "../amount/amount.component";
import { ButtonComponent } from "../button/button.component";
import { SvgComponent } from "../svg/svg.component";

interface Btn {
  icon?: SvgName;
  text: string;
  event: string;
  fn: () => void;
}

@Component({
  selector: "mn-calculator",
  templateUrl: "./calculator.component.html",
  styleUrls: ["./calculator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AmountComponent, ButtonComponent, SvgComponent, TranslatePipe],
})
export class CalculatorComponent {
  public amount = input<string>("");
  public min = input<string>("");
  public max = input<string>("");
  public precision = input<number>(0);
  public prefix = input<string>("");

  public amountChange = output<string>();

  public bG: Btn[][] = [
    [
      { text: "1", event: "1", fn: () => this.aN(1) },
      { text: "2", event: "2", fn: () => this.aN(2) },
      { text: "3", event: "3", fn: () => this.aN(3) },
      { text: ".", event: "dot", fn: () => this.aD() },
    ],
    [
      { text: "4", event: "4", fn: () => this.aN(4) },
      { text: "5", event: "5", fn: () => this.aN(5) },
      { text: "6", event: "6", fn: () => this.aN(6) },
      { text: "0", event: "0", fn: () => this.aN(0) },
    ],
    [
      { text: "7", event: "7", fn: () => this.aN(7) },
      { text: "8", event: "8", fn: () => this.aN(8) },
      { text: "9", event: "9", fn: () => this.aN(9) },
      { text: "", event: "delete", icon: "eraser", fn: () => this.dS() },
    ],
  ];

  protected onMaxClick(): void {
    this.amountChange.emit(`${this.max()}`);
  }

  protected onMinClick(): void {
    this.amountChange.emit(`${this.min()}`);
  }

  private aN(value: number): void {
    const amount = this.amount();

    if (amount.length < 16) {
      const [before, after] = amount.split(".");
      if (amount.includes(".")) {
        if (!after || after.length < this.precision()) {
          this.amountChange.emit(`${amount}${value}`);
        }
      } else {
        this.amountChange.emit(before === "0" ? `${value}` : `${before}${value}`);
      }
    }
  }

  private aD(): void {
    const amount = this.amount();

    if (this.precision() && amount.indexOf(".") === -1) {
      this.amountChange.emit(`${amount}.`);
    }
  }

  private dS(): void {
    const [before, after] = this.amount().split(".");
    if (after !== undefined) {
      if (after.length === 0) {
        this.amountChange.emit(before);
      } else if (after.length === 1) {
        this.amountChange.emit(`${before}.`);
      } else {
        this.amountChange.emit(`${before}.${after.slice(0, -1)}`);
      }
    } else {
      this.amountChange.emit(before.length === 1 ? "0" : before.slice(0, -1));
    }
  }
}
